// extracted by mini-css-extract-plugin
export var circle = "_aw-1";
export var exitConfirmationModal = "_aw-5";
export var iframe = "_aw-0";
export var offline = "_aw-3";
export var online = "_aw-2";
export var workstationSelectError = "_aw-4";